import { useState, useEffect } from "react";
import { Aside } from "./components/Aside";
import { MapContainer } from "./components/MapContainer";
import * as config from "./config";
import { LoadingModal } from "./components/LoadingModal";
import { StationsList } from "./components/StationsList";


const useFuelStations = (searchParams = {}) => {
  const [fuelStations, setFuelStations] = useState([]);
  const [totalResults, setTotalResults] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const params = Object.entries(searchParams)
        .filter(entry => Boolean(entry[1]))
        .map(entry => `${entry[0]}=${entry[1]}`)
        .join("&");

      const response = await fetch(`${config.SERVER_URL}/stations?${params}`);
      const data = await response.json();
      setFuelStations(data.stations);
      setTotalResults(data.totalResults);
      setIsLoading(false);
    })();
  }, [searchParams]);

  return {
    fuelStations,
    totalResults,
    isLoading
  }
}

export default function App() {
  const INITIAL_ZOOM = 6;
  const INITIAL_CENTER = [40.41831, -3.70275];
  const INITIAL_STATE = {
    mapZoom: INITIAL_ZOOM,
    mapCenter: INITIAL_CENTER,
    mapRadius: 1_000_000
  }

  const [searchParams, setSearchParams] = useState(INITIAL_STATE);
  const { fuelStations, totalResults, isLoading } = useFuelStations(searchParams);

  const onChangeSearchParam = (name, value) => {
    setSearchParams(oldState => {
      if (name === "province") {
        delete oldState.municipality;
        delete oldState.locality;
      }

      if (name === "municipality") {
        delete oldState.locality;
      }

      return {
        ...oldState,
        [name]: value
      }
    });
  }

  const resetFilters = () => {
    setSearchParams(INITIAL_STATE);
  }

  return <>
    <Aside
      searchParams={searchParams}
      onChangeSearchParam={onChangeSearchParam}
      resetFilters={resetFilters}
    />
    <main className="md:ml-96 relative">
      {isLoading && totalResults === 0 && <LoadingModal />}
      <MapContainer
        stations={fuelStations}
        mapZoom={searchParams.mapZoom}
        mapCenter={searchParams.mapCenter}
        setMapZoom={zoom => onChangeSearchParam("mapZoom", zoom)}
        setMapCenter={center => onChangeSearchParam("mapCenter", center)}
        setMapRadius={radius => onChangeSearchParam("mapRadius", radius)}
      />
      <StationsList
        stations={fuelStations}
        totalResults={totalResults}
      />
    </main>
  </>
}
